import { render, staticRenderFns } from "./PlvLiveLogin.vue?vue&type=template&id=361689ce&scoped=true&"
import script from "@/scripts/PlvLiveLogin/index.js?vue&type=script&lang=js&"
export * from "@/scripts/PlvLiveLogin/index.js?vue&type=script&lang=js&"
import style0 from "./PlvLiveLogin.vue?vue&type=style&index=0&id=361689ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361689ce",
  null
  
)

export default component.exports